import React, { useEffect } from "react";
import { CarouselProvider, useCarouselReducer } from "../context";
import styled from "styled-components";
import { useDirection } from "@radix-ui/react-direction";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { CarouselProgressBar } from "./CarouselProgressBar";
import { SkinId } from "../../../skins/types";
import { leagueClientSkin } from "../skins/league-client";
const _Carousel = ({ children, className, loop = false, draggable = false, currentSlide, axis = "x", direction: directionProp, align = "start", onSlideChange, breakpoints, ...props }) => {
    const directionContext = useDirection();
    const direction = directionProp ?? directionContext;
    const defaultCarouselArgs = React.useMemo(() => ({
        loop,
        draggable,
        align,
        direction,
        axis,
        breakpoints,
        currentSlide,
    }), [loop, draggable, align, direction, axis, breakpoints, currentSlide]);
    const [state, dispatch, setViewportRef] = useCarouselReducer(defaultCarouselArgs);
    const canScrollNext = state?.canScrollNext;
    const canScrollPrev = state?.canScrollPrev;
    const allSlidesVisible = !canScrollPrev && !canScrollNext;
    const { carouselId } = state;
    useEffect(() => {
        if (currentSlide !== undefined) {
            dispatch({ type: "goTo", index: currentSlide });
        }
    }, [currentSlide, dispatch]);
    useEffect(() => {
        if (state.activeSlideIndex !== undefined) {
            onSlideChange?.({ currentSlide: state.activeSlideIndex });
        }
    }, [state.activeSlideIndex, onSlideChange]);
    return (React.createElement("div", { className: ["embla", className].join(" "), "data-testid": "carousel", "data-active-slide": state.activeSlideIndex, "data-state-next": canScrollNext, "data-state-previous": canScrollPrev, "data-state-all-slides-visible": allSlidesVisible, role: "region", "aria-roledescription": "carousel", "aria-label": carouselId, id: carouselId, ...props },
        React.createElement(CarouselProvider, { value: { state, dispatch, setViewportRef } }, children || "")));
};
export const Carousel = styled(_Carousel) `
  ${mixinSkins({
    [SkinId.LeagueClient]: leagueClientSkin,
})}
  ${CarouselProgressBar} {
    .rail {
      height: 2px;
      width: 100%;
      background-color: #bcbcbc;
      margin-top: 10px;
    }
    .indicator {
      height: 2px;
      background-color: #050505;
    }
  }
`;
//# sourceMappingURL=Carousel.js.map